export default "__VITE_ASSET__curF84MA__"